import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, map, tap } from 'rxjs';
import { AppState } from '../../../../store/state/app.state';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';
import { AuthSelectors } from '../../store/selectors';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly store: Store<AppState>,
    private readonly router: Router,
    private readonly localStorageService: LocalStorageService
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.store.select(AuthSelectors.selectUserIsAdministrator).pipe(
      tap(isAdministrator => {
        if (!isAdministrator) {
          this.clearUser();
        }
      }),
      map(isAdministrator => (isAdministrator ? true : this.router.parseUrl('/auth/sign-in')))
    );
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

  private clearUser(): void {
    this.localStorageService.clearApiToken();
    this.localStorageService.clearUser();
  }
}
